import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "TopNewsNormal" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "TopNewsNormal__date" }
const _hoisted_4 = {
  key: 0,
  class: "c-label c-label--common"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item_list, (item, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("a", {
            href: `${_ctx.urlWhatsNewDetail}?id=${item.pk}`
          }, [
            _createElementVNode("dl", null, [
              _createElementVNode("dd", null, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatDate(item.start_showing)), 1),
                (item.author_name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.author_name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("dt", null, _toDisplayString(item.title), 1)
            ])
          ], 8, _hoisted_2)
        ]))
      }), 128))
    ])
  ]))
}